import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=5c9af0e6"
import script from "./Purchases.vue?vue&type=script&lang=ts"
export * from "./Purchases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports